import NeloApiClient from "@lib/clients/nelo-api-client"
import { baseHeaders, NEXT_PUBLIC_NELO_API_BASE_URL, PSEUDO_ID_COOKIE, PSEUDO_ID_HEADER, PSEUDO_ID_HEADER_LEGACY } from "@lib/constants"
import { getSessionCookie, getUtmParamSessionCookies } from "@lib/util/get-session-cookie-client"

const customHeaders: Record<string, string> = { ...baseHeaders }

const utmParams = getUtmParamSessionCookies()

for (const key in utmParams) {
  if (utmParams[key]) {
    customHeaders[key.replaceAll("_", "-")] = utmParams[key]
  }
}

const pseudoId = getSessionCookie(PSEUDO_ID_COOKIE)

if (pseudoId) {
  customHeaders[PSEUDO_ID_HEADER] = pseudoId
  customHeaders[PSEUDO_ID_HEADER_LEGACY] = pseudoId
}

export const neloApiClient = new NeloApiClient({
  baseUrl: NEXT_PUBLIC_NELO_API_BASE_URL,
  customHeaders: customHeaders,
})
